import React from 'react';
import { StarIcon, CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { trackEvent } from '../lib/metaPixel';
import { AudioPreview } from './AudioPreview';
export function Hero() {
  return <section className="relative w-full flex items-center py-8 sm:py-10 lg:py-12 overflow-hidden" data-id="element-126">
      {/* Subtle background glow - smaller on mobile to avoid render issues */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[300px] h-[300px] sm:w-[600px] sm:h-[600px] bg-teal/20 rounded-full blur-[80px] sm:blur-[120px] pointer-events-none" data-id="element-127" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 w-full grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-8 lg:gap-16 items-start relative z-10" data-id="element-128">
        {/* LEFT: Product Mockup + Audio Preview */}
        <div className="flex flex-col items-center lg:items-end gap-6 sm:gap-8" data-id="element-129">
          <img src="https://cdn.magicpatterns.com/uploads/mQ8cfsaH3zLeTQmEF2oL1K/FONDO_TRASPARENTE.png" alt="UNHOOKED book and tablet mockup — Break free from porn. Rewire your brain. Regain control." className="w-full max-w-lg lg:max-w-xl xl:max-w-2xl h-auto object-contain drop-shadow-2xl" data-id="element-130" />
          <div className="w-full max-w-md lg:max-w-lg" data-id="element-131">
            <AudioPreview data-id="element-132" />
          </div>
        </div>

        {/* RIGHT: Product Details */}
        <div className="flex flex-col" data-id="element-133">
          <div className="flex items-center gap-3 mb-4 justify-center sm:justify-start" data-id="element-134">
            <div className="flex" data-id="element-135">
              {[...Array(4)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current text-gold" data-id="element-136" />)}
              {/* 5th star: 90% gold, 10% ivory tip to represent 4.9 */}
              <div className="relative w-4 h-4" data-id="element-137">
                <StarIcon className="absolute inset-0 w-4 h-4 fill-current text-ivory" data-id="element-138" />
                <div className="absolute inset-0 overflow-hidden" style={{
                width: '90%'
              }} data-id="element-139">
                  <StarIcon className="w-4 h-4 fill-current text-gold" data-id="element-140" />
                </div>
              </div>
            </div>
            <span className="text-ivory/80 text-[11px] sm:text-sm tracking-[0.15em] sm:tracking-wider uppercase whitespace-nowrap" data-id="element-141">
              (4.9) · Verified Reviews
            </span>
          </div>

          <h1 className="font-serif text-[28px] sm:text-5xl lg:text-6xl xl:text-[60px] text-ivory mb-3 sm:mb-4 leading-[1.05] max-w-md break-words tracking-tight text-center sm:text-left mx-auto sm:mx-0" data-id="element-142">
            UNHOOKED
          </h1>

          <p className="text-[15px] sm:text-xl text-ivory/90 font-light mb-2 leading-snug text-center sm:text-left" data-id="element-143">
            Rewire Your Brain. Regain Control.
          </p>

          <p className="text-[13px] sm:text-base text-ivory/55 font-light mb-7 sm:mb-9 leading-relaxed tracking-wide text-center sm:text-left" data-id="element-144">
            A neuroscience-based approach to breaking compulsive porn use.
          </p>

          <ul className="space-y-2.5 mb-9" data-id="element-145">
            {['Understand the real mechanism behind compulsive porn use', 'Stop fighting urges with willpower', 'Restore focus, confidence, and mental clarity', 'Break the dopamine overstimulation cycle', 'Instant Private Access'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-146">
                <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-147" />
                <span className="text-ivory/80 text-[15px] sm:text-[15.5px] leading-snug" data-id="element-148">
                  {bullet}
                </span>
              </li>)}
          </ul>

          <div className="mb-8" data-id="element-149">
            <div className="flex items-baseline gap-4 mb-4 justify-center sm:justify-start" data-id="element-150">
              <span className="text-4xl font-serif text-ivory" data-id="element-151">$14.99</span>
              <span className="text-xl text-ivory/45 line-through decoration-gold/70 decoration-[1.5px]" data-id="element-152">
                $29.99
              </span>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-153">
              <label className="flex-1 relative cursor-pointer" data-id="element-154">
                <input type="radio" name="format" className="peer sr-only" defaultChecked data-id="element-155" />
                <div className="p-4 border border-gold/40 bg-charcoal-light rounded-md peer-checked:border-gold peer-checked:bg-teal/10 transition-all text-center sm:text-left" data-id="element-156">
                  <div className="text-ivory font-medium mb-1" data-id="element-157">Ebook Only</div>
                  <div className="text-ivory/60 text-sm" data-id="element-158">Instant Access</div>
                </div>
              </label>

              <label className="flex-1 relative cursor-not-allowed opacity-50" data-id="element-159">
                <input type="radio" name="format" className="peer sr-only" disabled data-id="element-160" />
                <div className="p-4 border border-charcoal-lighter bg-charcoal rounded-md text-center sm:text-left" data-id="element-161">
                  <div className="text-ivory font-medium mb-1" data-id="element-162">
                    Ebook + Audiobook
                  </div>
                  <div className="text-gold/80 text-sm uppercase tracking-wider text-xs mt-1" data-id="element-163">
                    Coming Soon
                  </div>
                </div>
              </label>
            </div>
          </div>

          <a href="https://vitalyforms.com/cart/50274454110428:1" onClick={() => trackEvent('AddToCart', {
          content_name: 'UNHOOKED Ebook',
          content_ids: ['50274454110428'],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        })} className="block w-full text-center bg-ivory text-charcoal hover:bg-white transition-all duration-300 py-5 rounded-md font-medium text-lg tracking-wide mb-4 shadow-glow-gold hover:scale-[1.02]" data-id="element-164">
            Start Reading Tonight
          </a>

          <div className="flex flex-col items-center gap-3" data-id="element-165">
            <div className="flex items-center gap-2 text-ivory/60 text-sm" data-id="element-166">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-167" />
              <span data-id="element-168">30-Day Money-Back Guarantee</span>
            </div>
            <div className="text-xs tracking-[0.15em] uppercase text-ivory/40 text-center" data-id="element-169">
              Private Purchase • Instant Access • Read On Any Device
            </div>
          </div>
        </div>
      </div>
    </section>;
}